module.exports = __webpack_public_path__ + "static/img/43.022a755.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/43.png
// module id = jtBU
// module chunks = 1